<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		@click:outside="closeDialog"
		@keydown.esc="closeDialog"
		@keydown.enter="setArguments"
	>
		<v-card class="sgnl-pb-4">
			<v-card-title class="dialog-header sgnl-subtitle-medium">
				Set command-line arguments
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeDialog"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-form
				v-model="formIsValid"
				@submit.prevent="setArguments"
			>
				<v-card-text class="dialog-body stack">
					<div class="input-group">
						<div class="field-label sgnl-text-color-default">Command-line arguments</div>
						<v-textarea
							v-model="runArguments"
							:rules="argumentRules"
							persistent-hint
							hint="Our platform will pass the command-line arguments specified above to your application when you
						run it."
						/>
					</div>
				</v-card-text>
				<v-divider />
				<v-card-actions class="dialog-footer">
					<v-btn
						variant="outlined"
						@click="closeDialog"
						>Cancel</v-btn
					>
					<v-btn
						variant="flat"
						color="primary"
						type="submit"
						:disabled="!formIsValid"
					>
						Set Arguments
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";

const maxArgLength = 100_000;
export default defineComponent({
	name: "RunArgumentsDialog",
	components: { Close16 },
	props: {
		showDialog: { type: Boolean, default: false },
		initialRunArguments: { type: String, default: "" },
	},
	emits: ["close-dialog", "set-arguments", "update:showDialog"],
	data: () => ({
		runArguments: "",
		maxArgLength: maxArgLength,
		formIsValid: false,
		argumentRules: [
			(value) => {
				const validArgumentCharacters = !value.includes("\n");
				return validArgumentCharacters || "Command-line arguments cannot include line breaks.";
			},
			(value) => {
				const validArgumentLength = value.length < maxArgLength;
				return (
					validArgumentLength || `Maximum command-line argument length allowed is ${maxArgLength} characters.`
				);
			},
		],
	}),
	computed: {
		localShowDialog: {
			get(): boolean {
				return this.showDialog;
			},
			set(value: boolean) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("close-dialog");
		},
		setArguments() {
			this.$emit("set-arguments", { runArguments: this.runArguments });
			this.$posthog?.capture("editor_run_arguments_set", { has_arguments: !!this.runArguments?.trim() });
		},
	},
	mounted() {
		this.runArguments = this.initialRunArguments;
	},
});
</script>
